import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 数据字典列表
    getDictionarylist({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsData/GetGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存字典
    saveDictionary({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/ItemsData/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除字典
    DeleteDictionary({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/ItemsData/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 字典左侧树
    getDictionarytree({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsType/GetTreeJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 字典分类列表
    GetDictionaryclass({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsType/GetTreeGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 字典分类列表
    Getsuperiordata({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsType/GetTreeSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存分类
    saveclassification({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/ItemsType/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除分类
    Delclassification({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/ItemsType/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
